import { render, staticRenderFns } from "./virtualize.vue?vue&type=template&id=6bc8468b&scoped=true&"
import script from "./virtualize.vue?vue&type=script&lang=ts&"
export * from "./virtualize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8468b",
  null
  
)

export default component.exports